import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASEPATH_PATHWAY } from '@/config/env.config';
import { createBaseQueryWithAuth } from '../baseQueryWithAuth';

export const pathwayExplorerApi = createApi({
	reducerPath: 'pathwayExplorer',
	tagTypes: ['samplesets'],
  baseQuery: createBaseQueryWithAuth(API_BASEPATH_PATHWAY),
  endpoints: () => ({}),
});